function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgTrx = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M18.559 9.2c-.6-.426-1.24-.88-1.868-1.33-.014-.01-.027-.02-.045-.031a.839.839 0 00-.246-.14l-.007-.004c-1.678-.412-3.355-.825-5.032-1.24L6.873 5.346l-.118-.032a1.14 1.14 0 00-.457-.06.316.316 0 00-.128.05l-.042.035a.517.517 0 00-.117.19L6 5.558v.161l.008.025c.944 2.689 1.915 5.417 2.851 8.056.72 2.032 1.47 4.137 2.2 6.204.046.14.174.232.334.246h.034a.389.389 0 00.347-.194l2.745-4.06 2.006-2.966.821-1.216c.45-.668.915-1.357 1.376-2.028l.024-.035V9.71c.01-.123.014-.376-.187-.51zm-3.216 1.48c-.645.34-1.303.691-1.965 1.04l1.158-1.259c.481-.527.984-1.073 1.476-1.607l.01-.01c.042-.056.094-.109.15-.165.037-.038.079-.077.117-.123.257.18.516.362.766.541.18.13.364.26.551.39-.757.393-1.511.79-2.263 1.192zm-1.656-.17c-.496.545-1.009 1.104-1.518 1.656-.989-1.216-1.98-2.43-2.974-3.642L7.861 6.897l-.003-.004c-.1-.115-.198-.242-.295-.361-.062-.081-.128-.159-.194-.24.402.105.808.204 1.206.299.35.085.714.172 1.07.264l6.035 1.486c-.67.725-1.342 1.46-1.993 2.17zm-1.744 6.851c.038-.369.08-.748.115-1.121.031-.3.062-.605.094-.896.048-.468.1-.953.142-1.428l.01-.084c.034-.303.069-.615.09-.928.04-.023.082-.043.125-.06.052-.024.104-.045.155-.077.8-.426 1.603-.85 2.405-1.272.801-.422 1.623-.858 2.437-1.29a706.411 706.411 0 00-2.208 3.262c-.62.916-1.258 1.862-1.892 2.794-.249.373-.51.752-.755 1.117-.278.408-.562.826-.839 1.245.035-.422.076-.847.121-1.262zM7.113 7.122c-.045-.127-.095-.257-.136-.38.936 1.146 1.878 2.3 2.797 3.417.475.58.95 1.156 1.424 1.74.094.109.188.225.278.337.117.144.235.296.363.44-.042.361-.076.727-.114 1.078a56.18 56.18 0 01-.076.743v.003c-.01.157-.031.316-.049.47l-.08.7-.003.024c-.062.71-.139 1.428-.211 2.124-.031.288-.059.583-.09.879-.018-.053-.038-.106-.056-.155a15.799 15.799 0 01-.152-.433l-.371-1.044-3.525-9.943",
    fill: "white"
  }));
});
SvgTrx.displayName = "SvgTrx";
SvgTrx.defaultProps = {
  size: 24,
  color: "black"
};
export default SvgTrx;